import { render, staticRenderFns } from "./CourseStudentsSection.vue?vue&type=template&id=1ecf11ac&"
import script from "./CourseStudentsSection.vue?vue&type=script&lang=ts&"
export * from "./CourseStudentsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports